// src/components/MainContent.js
import { faBox, faComments, faHeart, faShieldHalved, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const navItems = [
  { to: "/projects", label: "Projects", icon: faBox },
  { to: "/admin", label: "Admin", icon: faUserShield },
  { to: "/trademarking", label: "Trademarking", icon: faShieldHalved },
  { to: "/liked-names", label: "Liked Names", icon: faHeart },
  { to: "/chat", label: "Chat", icon: faComments },
];

const CircularNav = () => {
  const radius = 140;
  const angleOffset = -90;

  return (
    <div className="relative w-[350px] h-[350px]">
      {navItems.map((item, i) => {
        const angle = (360 / navItems.length) * i + angleOffset;
        const radian = (angle * Math.PI) / 180;
        const x = Math.cos(radian) * radius;
        const y = Math.sin(radian) * radius;

        return (
          <Link
            key={item.to}
            to={item.to}
            className="absolute left-1/2 top-1/2"
            style={{
              transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`,
            }}
          >
            <div className="flex flex-col items-center gap-2 p-3 group">
              <div className="w-14 h-14 rounded-full bg-primary flex items-center justify-center transition-all group-hover:ring-4 group-hover:ring-primary/20">
                <FontAwesomeIcon icon={item.icon} className="text-primary-content text-lg" />
              </div>
              <span className="text-[10px] uppercase tracking-wider text-base-content/50 group-hover:text-base-content transition-colors whitespace-nowrap">
                {item.label}
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

// Grid nav for mobile - same buttons, centered rows
const GridNav = () => (
  <nav className="flex flex-col items-center gap-2">
    {/* First row - 3 items */}
    <div className="flex justify-center gap-2">
      {navItems.slice(0, 3).map(item => (
        <Link key={item.to} to={item.to}>
          <div className="flex flex-col items-center gap-2 p-2 group w-20">
            <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center transition-all group-hover:ring-4 group-hover:ring-primary/20">
              <FontAwesomeIcon icon={item.icon} className="text-primary-content" />
            </div>
            <span className="text-[9px] uppercase tracking-wider text-base-content/50 group-hover:text-base-content transition-colors text-center leading-tight">
              {item.label}
            </span>
          </div>
        </Link>
      ))}
    </div>
    {/* Second row - 2 items centered */}
    <div className="flex justify-center gap-2">
      {navItems.slice(3).map(item => (
        <Link key={item.to} to={item.to}>
          <div className="flex flex-col items-center gap-2 p-2 group w-20">
            <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center transition-all group-hover:ring-4 group-hover:ring-primary/20">
              <FontAwesomeIcon icon={item.icon} className="text-primary-content" />
            </div>
            <span className="text-[9px] uppercase tracking-wider text-base-content/50 group-hover:text-base-content transition-colors text-center leading-tight">
              {item.label}
            </span>
          </div>
        </Link>
      ))}
    </div>
  </nav>
);

export const MainContent = ({ user, handleSignOut, getCustomAvatar }) => (
  <div className="relative z-10 flex flex-col md:flex-row items-center gap-6 md:gap-12 p-4 md:p-6">
    {/* Logo section */}
    <div className="flex flex-col items-center">
      <img src="/logo.svg" alt="Monika Logo" className="logo w-52 md:w-auto" />
      <h3 className="title mt-2">A moniker delivery system.</h3>

      {user?.displayName && (
        <div className="flex items-center gap-3 mt-4 md:mt-6">
          <img
            src={getCustomAvatar()}
            alt="Avatar"
            className="w-7 h-7 md:w-8 md:h-8 rounded-full cursor-pointer hover:ring-2 hover:ring-primary/30 transition-all"
            onClick={handleSignOut}
            title="Sign out"
            referrerPolicy="no-referrer"
          />
          <span className="text-xs md:text-sm text-base-content/50">{user.displayName.split(" ")[0]}</span>
        </div>
      )}
    </div>

    {/* Mobile grid nav */}
    <div className="md:hidden">
      <GridNav />
    </div>

    {/* Desktop circular nav */}
    <div className="hidden md:block">
      <CircularNav />
    </div>
  </div>
);

export default MainContent;
